import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import "./ImportFilePreviewModal.css";

const MAX_PREVIEW_ROWS = 500;

const ImportFilePreviewModal = ({
  open,
  onClose,
  loading,
  error,
  fileName,
  columns,
  rows,
  truncated,
  notPreviewable,
  onDownload,
}) => {
  const safeColumns = columns ? columns : [];
  const safeRows = rows ? rows : [];
  const displayRows = safeRows.slice(0, MAX_PREVIEW_ROWS);
  const isCapped = truncated || safeRows.length > MAX_PREVIEW_ROWS;

  const renderBody = () => {
    if (loading) {
      return <div className="text-center p-4">Loading file...</div>;
    }
    if (error) {
      return <div className="text-danger p-3">{error}</div>;
    }
    if (notPreviewable) {
      return (
        <div className="p-3">This file type cannot be previewed here.</div>
      );
    }
    if (safeColumns.length === 0) {
      return <div className="p-3">This file appears to be empty.</div>;
    }
    return (
      <div className="table-responsive import-preview-table-wrap">
        <table className="table table-sm table-bordered mb-0">
          <thead>
            <tr>
              {safeColumns.map((col, i) => (
                <th key={i} className="text-nowrap">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {displayRows.map((row, r) => (
              <tr key={r}>
                {safeColumns.map((col, c) => (
                  <td key={c}>{row[col]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {isCapped ? (
          <div className="text-muted small mt-2">
            Showing first {displayRows.length} rows
            {truncated ? " (large file truncated)" : ""}.
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  return (
    <Modal isOpen={open} toggle={onClose} size="xl">
      <ModalHeader toggle={onClose}>
        {fileName ? fileName : "File preview"}
      </ModalHeader>
      <ModalBody>{renderBody()}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
        <Button color="primary" onClick={onDownload}>
          Download
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ImportFilePreviewModal;
